<script lang="ts" setup>
    import { useMenuStore } from '@/stores/menu';
    import eventBus from '@/services/eventBus';
    import { useI18n } from 'vue-i18n';
    import { useDisplay, useTheme } from 'vuetify';
    import { notificationService } from '@/services/notificationService';
    import { dateFormatInUserTimeZone } from '@/helpers';
    import { useAppStore } from '@/stores/app';
    import { EventName } from '@/constants';

    const theme = useTheme();
    const display = useDisplay();
    const { t } = useI18n();

    const menuStore = useMenuStore();
    const appStore = useAppStore();

    const filterNotifications = computed(() => {
        return appStore.notifications.slice(0, 5);
    });

    const dismissAll = (): void => {
        notificationService.dismissAll().then((response) => {
            if (response.data.success) {
                appStore.notifications = [];
                menuStore.notificationMenu = false;

                eventBus.emit(EventName.PageResize);
            }
        });
    };

    onMounted((): void => {
        console.log('Component app-menuNotification mounted.');
    });
</script>
<template>
    <v-menu offset-y v-model="menuStore.notificationMenu" :close-on-content-click="false" :close-on-click="true" :nudge-width="200" offset-x>
        <template v-slot:activator="{ props }">
            <v-badge :model-value="appStore.notifications.length !== 0" color="orange" dot overlap :offset-x="display.xs.value ? 3 : 9" :offset-y="display.xs.value ? 3 : 9">
                <v-btn
                    :data-tooltip="t('menu.notifications')"
                    tag="a"
                    class="link-menu"
                    :height="display.xs.value ? 30 : 46"
                    min-width="30"
                    :width="display.xs.value ? 30 : 50"
                    variant="text"
                    v-bind="props"
                >
                    <v-icon size="24" :color="theme.name.value === 'dark' ? '' : '#867878'" :icon="mdiBellOutline" />
                </v-btn>
            </v-badge>
        </template>

        <v-card width="350px" variant="outlined">
            <v-list class="py-0">
                <div class="px-2" v-if="filterNotifications.length">
                    <v-list-item v-for="(notification, index) in filterNotifications" :key="index" class="px-0">
                        <v-row class="py-0 ma-0 font13" dense>
                            <v-col cols="2" class="pr-0 pl-0">
                                <span class="text-grey">
                                    {{ dateFormatInUserTimeZone(notification.createdAt, 'MMM dd') }}
                                </span>
                            </v-col>
                            <v-col cols="10" class="pl-0">
                                <span v-html="notification.text"></span>
                            </v-col>
                        </v-row>
                    </v-list-item>
                </div>
                <span v-else>
                    <p class="font13 text-center mb-0 pt-1 pb-1 font-weight-light">
                        {{ t('menu.noUnreadNotifications') }}
                    </p>
                </span>
            </v-list>
            <v-card-actions class="pt-0">
                <v-btn density="default" tag="a" :color="theme.name.value === 'dark' ? 'white' : 'grey'" variant="text" class="px-1">
                    <router-link to="/notifications" @click="menuStore.notificationMenu = false">
                        {{ t('menu.allNotifications') }}
                    </router-link>
                </v-btn>
                <v-spacer></v-spacer>

                <v-btn density="default" tag="a" v-if="filterNotifications.length" color="grey" variant="text" class="px-1">
                    <a @click="dismissAll">{{ t('menu.dismissAll') }}</a>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>
<style scoped>
    .v-list-item:hover {
        background-color: #fafafa;
    }

    .v-theme--dark .v-list-item:hover {
        background-color: #2b2c30;
    }

    .v-list-item {
        min-height: 40px;
    }

    .v-card-actions a {
        text-decoration: none;
        color: grey;
    }

    .v-theme--light.v-card--variant-outlined {
        border: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-theme--dark.v-card--variant-outlined {
        background-color: #1e1f22 !important;
        border: 1px solid #404148 !important;
    }
</style>
